import Vue from 'vue';
import App from './App.vue';
import router from './router';
import { i18n } from './language';
import store from './store/index';

Vue.config.productionTip = false;

console.log(process);
console.log(process.env);

const vm = new Vue({
  router,
  store,
  i18n,
  data() {
    return {
      locale: 'de',
      title: document.title,
    };
  },
  render: h => h(App),
}).$mount('#app');

Vue.filter('translate', (value) => {
  if (!value) return '';
  if (!value[vm.$i18n.locale]) return value;
  return value[vm.$i18n.locale];
});
